import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';
import Footer from './Footer';
import Headermain from './Headermain';
import Slidemenu from './Slidemenu';
import search from '../assets/images/search.png';
import { Menu, Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import Nothing_here from './Nothing_here';
import Common_Pagination from './Common_Pagination';


class Yourorders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Booking History</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="banner-dropdown-search-box-wrapper use-loaction-header profile-location-dropdown">
                                        <div className="banner-dropdown-search-area">
                                            <div className="banner-location-dropdown">
                                                <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']} onClick={(e) => e.preventDefault()}>
                                                    <a onClick={(e) => e.preventDefault()}>
                                                    <Space>
                                                        Select Location
                                                        <DownOutlined />
                                                    </Space>
                                                    </a>
                                                </Dropdown>
                                            </div>
                                            <div className="banner-search-input-box" onClick={(e) => e.preventDefault()}>
                                                <span className="search-icon-box">
                                                    <img src={search} alt="" />
                                                </span>
                                                <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                            </div>
                                        </div>
                                </div>
                                <Slidemenu  prop={this.props} />
                                <div className="booking-history common-content content">
                                    <h3>Booking History</h3>
                                    <div className="booking-history-wrapper">
                                        <div className="booking-history-content-inner ">
                                            <div className="booking-history-info">
                                                <div className="booking-info-header flex-box">
                                                    <div className="booking-id-status-box flex-box">
                                                        <div className="booking-id-block">
                                                            <h5 className='ref-title'>Ref No. #1234567</h5>
                                                        </div>
                                                        <ul className="booking-status-block">
                                                            <li className="light-green-label booking-status confirm-label">Confirmed</li>
                                                        </ul>
                                                    </div>
                                                    <div className="booking-control-box flex-box">
                                                        <div className="menu-block">
                                                            <button className="" type="button" class="btn dropdown-toggle dropdown-toggle-split custom-three-dot-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span class="visually-hidden">Toggle Dropdown</span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                            </button>
                                                            <ul className="dropdown-menu custom-drop-menu three-dot-menu">
                                                                <li><a className="dropdown-item" href="#">Link 1</a></li>
                                                                <li><a className="dropdown-item" href="#">Link 2</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="button-block">
                                                            <button className="download-report-btn main-btn btn-hidden">Download Report</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="booking-detail-main">
                                                    <ul className="booking-detail-row flex-box">
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Date & Time</h6>
                                                                <p className="booking-detail-description">
                                                                    May 20, 2022
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    10:10 AM
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Patient & Address</h6>
                                                                <p className="booking-detail-description">
                                                                    Vikash Gupta, M, 32 Yrs
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    V43A, Amit Nagar, Jay
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Tests</h6>
                                                                <p className="booking-detail-description">
                                                                    Cbc Hemogram Test, Test2, Test3
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Lab</h6>
                                                                <p className="booking-detail-description">
                                                                    Toprani Advanced Lab Systems
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    Suflam Appartment
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="booking-history-content-inner ">
                                            <div className="booking-history-info">
                                                <div className="booking-info-header flex-box">
                                                    <div className="booking-id-status-box flex-box">
                                                        <div className="booking-id-block">
                                                            <h5 className='ref-title'>Ref No. #2424225</h5>
                                                        </div>
                                                        <ul className="booking-status-block">
                                                            <li className="light-green-label booking-status assigned-label">Phlebotomist Assigned</li>
                                                        </ul>
                                                    </div>
                                                    <div className="booking-control-box flex-box">
                                                        <div className="menu-block">
                                                            <button className="" type="button" class="btn dropdown-toggle dropdown-toggle-split custom-three-dot-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span class="visually-hidden">Toggle Dropdown</span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                            </button>
                                                            <ul className="dropdown-menu custom-drop-menu three-dot-menu" >
                                                                <li><a className="dropdown-item" href="#">Link 1</a></li>
                                                                <li><a className="dropdown-item" href="#">Link 2</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="button-block">
                                                            <button className="download-report-btn main-btn btn-hidden">Download Report</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="booking-detail-main">
                                                    <ul className="booking-detail-row flex-box">
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Date & Time</h6>
                                                                <p className="booking-detail-description">
                                                                    May 18, 2022
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    10:10 AM
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Patient & Address</h6>
                                                                <p className="booking-detail-description">
                                                                    Anjali Gupta, F, 31 Yrs
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    V43A, Amit Nagar, Jay
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Tests</h6>
                                                                <p className="booking-detail-description">
                                                                    Cbc Hemogram Test, Thyroid panel
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Lab</h6>
                                                                <p className="booking-detail-description">
                                                                    Deep Pathology Laboratory
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    111, Avanti Chambers, more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="booking-history-content-inner ">
                                            <div className="booking-history-info">
                                                <div className="booking-info-header flex-box">
                                                    <div className="booking-id-status-box flex-box">
                                                        <div className="booking-id-block">
                                                            <h5 className='ref-title'>Ref No. #1254623</h5>
                                                        </div>
                                                        <ul className="booking-status-block">
                                                            <li className="light-green-label booking-status collected-label">Sample Collected</li>
                                                        </ul>
                                                    </div>
                                                    <div className="booking-control-box flex-box">
                                                        <div className="menu-block">
                                                            <button className="" type="button" class="btn dropdown-toggle dropdown-toggle-split custom-three-dot-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span class="visually-hidden">Toggle Dropdown</span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                            </button>
                                                            <ul className="dropdown-menu custom-drop-menu three-dot-menu">
                                                                <li><a className="dropdown-item" href="#">Link 1</a></li>
                                                                <li><a className="dropdown-item" href="#">Link 2</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="button-block">
                                                            <button className="download-report-btn main-btn btn-hidden">Download Report</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="booking-detail-main">
                                                    <ul className="booking-detail-row flex-box">
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Date & Time</h6>
                                                                <p className="booking-detail-description">
                                                                    May 17, 2022
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    10:10 AM
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Patient & Address</h6>
                                                                <p className="booking-detail-description">
                                                                    Vikash Gupta, M, 32 Yrs
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    24, Indu Heights, Babaji more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Tests</h6>
                                                                <p className="booking-detail-description">
                                                                    Vitamin B12, Hemoglobin
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Lab</h6>
                                                                <p className="booking-detail-description">
                                                                    Shakti Pathology Lab
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    9, Ground Floor, Harsh more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="booking-history-content-inner ">
                                            <div className="booking-history-info">
                                                <div className="booking-info-header flex-box">
                                                    <div className="booking-id-status-box flex-box">
                                                        <div className="booking-id-block">
                                                            <h5 className='ref-title'>Ref No. #2385161</h5>
                                                        </div>
                                                        <ul className="booking-status-block">
                                                            <li className="light-green-label booking-status in-progress-label">Test in Process</li>
                                                        </ul>
                                                    </div>
                                                    <div className="booking-control-box flex-box">
                                                        <div className="menu-block">
                                                            <button className="" type="button" class="btn dropdown-toggle dropdown-toggle-split custom-three-dot-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span class="visually-hidden">Toggle Dropdown</span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                            </button>
                                                            <ul className="dropdown-menu custom-drop-menu three-dot-menu ">
                                                                <li><a className="dropdown-item" href="#">Link 1</a></li>
                                                                <li><a className="dropdown-item" href="#">Link 2</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="button-block">
                                                            <button className="download-report-btn main-btn btn-hidden">Download Report</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="booking-detail-main">
                                                    <ul className="booking-detail-row flex-box">
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Date & Time</h6>
                                                                <p className="booking-detail-description">
                                                                    May 17, 2022
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    10:10 AM
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Patient & Address</h6>
                                                                <p className="booking-detail-description">
                                                                    Saurya Gupta, M, 10 Yrs
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    24, Indu Heights, Babaji more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Tests</h6>
                                                                <p className="booking-detail-description">
                                                                    Lipid Profile
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Lab</h6>
                                                                <p className="booking-detail-description">
                                                                    Siddha Pathology Laboratory
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    6,Tarang Society, Opp
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="booking-history-content-inner ">
                                            <div className="booking-history-info">
                                                <div className="booking-info-header flex-box">
                                                    <div className="booking-id-status-box flex-box">
                                                        <div className="booking-id-block">
                                                            <h5 className='ref-title'>Ref No. #2461535</h5>
                                                        </div>
                                                        <ul className="booking-status-block">
                                                            <li className="light-green-label booking-status report-uploaded-label">Report Uploaded</li>
                                                        </ul>
                                                    </div>
                                                    <div className="booking-control-box flex-box">
                                                        <div className="menu-block">
                                                            <button className="" type="button" class="btn dropdown-toggle dropdown-toggle-split custom-three-dot-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <span class="visually-hidden">Toggle Dropdown</span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                                <span className="menu-dots"></span>
                                                            </button>
                                                            <ul className="dropdown-menu custom-drop-menu three-dot-menu">
                                                                <li><a className="dropdown-item" href="#">Link 1</a></li>
                                                                <li><a className="dropdown-item" href="#">Link 2</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="button-block">
                                                            <button className="download-report-btn main-btn">Download Report</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="booking-detail-main">
                                                    <ul className="booking-detail-row flex-box">
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Date & Time</h6>
                                                                <p className="booking-detail-description">
                                                                    May 16, 2022
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    10:10 AM
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Patient & Address</h6>
                                                                <p className="booking-detail-description">
                                                                    Anjali Gupta, F, 31 Yrs
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    24, Indu Heights, Babaji more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Tests</h6>
                                                                <p className="booking-detail-description">
                                                                    Cbc Hemogram Test, Blood Urea Nitrogen
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="booking-detail-col">
                                                            <div className="booking-detail-box">
                                                                <h6 className="booking-detail-title">Lab</h6>
                                                                <p className="booking-detail-description">
                                                                    Toprani Advanced Lab Systems
                                                                </p>
                                                                <span className="booking-more-detail">
                                                                    Suflam Appartment, more...
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Common_Pagination /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default Yourorders;